import React, { useEffect, useRef } from 'react';
import watsIcon from '../assest/home/5357b4eb16238760df0ba166628f1cee41086e44.png';
import styleMark from '../css/backgrounds/markService.module.css';
import { Link } from 'react-router-dom';
import '../css/AllServices.css'; // استخدام نفس ملف الأنيميشن

function MarketingServices() {
    const serviceRefs = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate-in');
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            }
        );

        serviceRefs.current.forEach((ref) => {
            if (ref) observer.observe(ref);
        });

        return () => {
            serviceRefs.current.forEach((ref) => {
                if (ref) observer.unobserve(ref);
            });
        };
    }, []);

    const addToRefs = (el, index) => {
        if (el && !serviceRefs.current.includes(el)) {
            serviceRefs.current[index] = el;
        }
    };

    return (
        <div className="services-name">
            <div className={`${styleMark.back1} service-item`} ref={(el) => addToRefs(el, 0)}>
                <h1>إدراة وتنظيم الحفلات والمؤتمرات</h1>
                <div>
                    <span><Link to='/services/manorgevCon'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن تنظيم حفلات و مؤتمرات'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className={`${styleMark.back2} service-item`} ref={(el) => addToRefs(el, 1)}>
                <h1>تفعيل تابي وتمارا</h1>
                <div>
                    <span><Link to='/services/actTabtam'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن تفعيل تابي وتمارا'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className={`${styleMark.back3} service-item`} ref={(el) => addToRefs(el, 2)}>
                <h1>تطوير صفحات الويب</h1>
                <div>
                    <span><Link to='/services/devweb'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن تطوير صفحات الويب'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className={`${styleMark.back4} service-item`} ref={(el) => addToRefs(el, 3)}>
                <h1>رفع جوجل ماب</h1>
                <div>
                    <span><Link to='/services/upmap'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن رفع جوجل ماب'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className={`${styleMark.back5} service-item`} ref={(el) => addToRefs(el, 4)}>
                <h1>رفع العلامات التجارية</h1>
                <div>
                    <span><Link to='/services/raibra'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن رفع العلامة التجارية'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className={`${styleMark.back6} service-item`} ref={(el) => addToRefs(el, 5)}>
                <h1>إدارة وتنظيم المتاجر الالكترونية</h1>
                <div>
                    <span><Link to='/services/manorgEst'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966531906999?text=السلام عليكم اريد استفسر عن إدارة المتاجر الالكترونية'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className={`${styleMark.back7} service-item`} ref={(el) => addToRefs(el, 6)}>
                <h1>إدارة حسابات السوشيال ميديا</h1>
                <div>
                    <span><Link to='/services/mansocacc'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن إدارة حسابات السوشيال ميديا'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className={`${styleMark.back8} service-item`} ref={(el) => addToRefs(el, 7)}>
                <h1>تصوير المنتجات</h1>
                <div>
                    <span><Link to='/services/propho'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن تصوير المنتجات'>أطلب الان</Link>
                    </span>
                </div>
            </div>
        </div>
    )
}

export default MarketingServices;